import React from "react"
import PropTypes from "prop-types"
import GridContainer from "../../../components/layouts/containers/GridContainer.container"
import GridItem from "../../../components/layouts/containers/GridItem.container"
import { ValueWithLabelTemplate } from "../../../components/layouts/containers/ValueWithLabelElements.container"
import VacationFlag from "../../../components/molecules/VacationFlag.molecule"
import VacationDayTypesBreakdown from "./VacationDayTypesBreakdown.molecule"
import {
  getVacationRangeLabel,
  isVacationRequestCanceledByTeamMemberRequest,
} from "../../../utils/vacation.utils"
import { DateTime } from "luxon"
import VacationRequestDifferenceDays from "./VacationRequestDifferenceDays"
import { VACATION_APPROVED_STATUS } from "../../../consts/modules/vacations.consts"

const VacationRequestSummary = ({ vacationRequest }) => {
  return (
    <GridContainer className="vacation-request-summary">
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Integrante"
          value={
            <div className="flex gap-2 align-items-center">
              <span>{vacationRequest.teamMember.fullName}</span>
              <VacationFlag
                schemaTitle={vacationRequest.teamMember.holidaySchemaName}
              />
            </div>
          }
        />
      </GridItem>
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Fecha de la solicitud"
          value={DateTime.fromISO(vacationRequest.createdAt).toFormat(
            "dd/MM/yyyy"
          )}
        />
      </GridItem>
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Fechas solicitadas"
          value={getVacationRangeLabel(
            vacationRequest.numberOfVacationDays,
            vacationRequest.startDate,
            vacationRequest.endDate,
            {
              includeNumberOfDays: false,
              includeDateRange: true,
              dateFormat: "dd/MM/yyyy",
            }
          )}
        />
      </GridItem>
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Cantidad de días"
          value={
            <div className="flex gap-2">
              {vacationRequest?.numberOfVacationDays}
              <VacationDayTypesBreakdown vacationRequest={vacationRequest} />
            </div>
          }
        />
      </GridItem>
      <GridItem col={6}>
        <ValueWithLabelTemplate
          label="Motivo"
          value={vacationRequest.vacationsMotive}
        />
      </GridItem>
      {isVacationRequestCanceledByTeamMemberRequest(vacationRequest) && (
        <GridItem col={6}>
          <ValueWithLabelTemplate
            label="Razón de la cancelación"
            value={vacationRequest?.cancelationMotive}
          />
        </GridItem>
      )}
      {vacationRequest.approved === VACATION_APPROVED_STATUS.NOT_REVIEWED && (
        <VacationRequestDifferenceDays
          before={vacationRequest.totalVacationDays}
          after={vacationRequest.differenceVacationDays}
          holidaySchema={
            vacationRequest.holidaySchema ||
            vacationRequest.teamMember.holidaySchemaName
          }
          usedDays={{
            bucketDays: vacationRequest.numberOfBucketDays || 0,
            plusDays: vacationRequest.numberOfPlusDays || 0,
            accordedDays: vacationRequest.numberOfAccordedDays || 0,
            additionalDays: vacationRequest.numberOfAdditionalDays || 0,
          }}
        />
      )}
    </GridContainer>
  )
}

export default VacationRequestSummary

VacationRequestSummary.propTypes = {
  vacationRequest: PropTypes.shape({
    teamMember: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
      holidaySchemaName: PropTypes.string.isRequired,
      idHolidaySchema: PropTypes.number.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    numberOfVacationDays: PropTypes.number.isRequired,
    vacationsMotive: PropTypes.string.isRequired,
  }).isRequired,
}
